var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
import Carousel from 'bootstrap/js/dist/carousel';
export class CarouselComponent extends Component {
    constructor() {
        super('CarouselComponent', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').forEach((carousel) => {
                let bsCarousel = new Carousel(carousel);
                if ($(carousel).parents('.module-banner').length > 0) {
                    carousel.style.opacity = '0';
                    bsCarousel.to(Math.floor(Math.random() * $(carousel).find('.carousel-item').length));
                    setTimeout(() => {
                        carousel.style.opacity = '1';
                    }, 500);
                    $(window).on('resize', () => {
                        this.positionLegend(carousel);
                    });
                    $(carousel).on('slid.bs.carousel', () => {
                        this.positionLegend(carousel);
                    });
                    this.positionLegend(carousel);
                }
            });
            this.success();
        });
    }
    positionLegend(carousel) {
        if ($(carousel).find('.carousel-item.active .carousel-caption').length == 0)
            return;
        let carouselDimensions = carousel.getBoundingClientRect();
        let captionDimensions = $(carousel).find('.carousel-item.active .carousel-caption').get(0).getBoundingClientRect();
        let center = captionDimensions.height + ((carouselDimensions.height - captionDimensions.height) / 2);
        $(carousel).find('.carousel-indicators').get(0).style.bottom = center + 'px';
    }
}
